import React from "react";
import '../../index.css'; // Assume CSS styles are saved in this file

const FineDiningExample = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">Use Case Description - Fine Dining (Suitable for scenarios where dishes are served by table number, such as Western dining, hot pot, barbecue, etc.)</h1>

      <div className="section">
        <p className="store-info">Nali is a hot pot restaurant located in Mexico, with two kitchens for side dishes and stir-fries, and the service process is as follows:</p>
        <ol>
          <li>Customers are seated, order through scanning QR codes or with the help of waitstaff.</li>
          <li>Tickets are issued separately by the hot pot side dish and stir-fry kitchens.</li>
          <li>After the kitchens prepare the dishes, waitstaff serve them to the tables.</li>
          <li>After dining, customers proceed to the cashier or contact waitstaff to pay the bill.</li>
          <li>After cleaning the table, it is prepared for the next customer.</li>
        </ol>
        <p>In addition, the client has the following requirements:</p>
        <ol>
          <li>Membership registration is required, with a promotion offering $300 bonus for every $1000 recharged for existing customers.</li>
          <li>Tax requirements, needing the system to automatically calculate taxes and reflect this on receipts.</li>
          <li>Some dishes are only available on weekend mornings, with an automatic delisting after the time passes.</li>
          <li>The restaurant has several partners, who want to be able to view the restaurant's financials.</li>
          <li>Desire to export order details for further data analysis.</li>
        </ol>
      </div>

      <div className="section">
        <h2>Role Distribution</h2>
        <ol>
          <li>The manager logs into their account on a mobile phone to manage restaurant settings and view reports, but does not directly handle orders. {/*[follow with a screenshot]*/}</li>
          <img src="./meal/img_1.png" />
          <li>Staff log into the cashier account on a computer, responsible for connecting to printers and handling orders, such as placing orders, adding dishes, cancelling dishes, settling bills, and printing receipts. {/*[follow with a screenshot]*/}</li>
          <img src="./meal/img_2.png"/>
          <li>Each waiter uses their own mobile phone to log into their personal waiter account, which can assist customers with ordering, add dishes, settle bills, and connect to a printer to print receipts. {/*[follow with a screenshot]*/}</li>
          <img src="./meal/img_3.png" alt=""/>
          <li>Partners log into their partner account on their mobile phones, which allows them to see the restaurant's business information but does not allow them to modify settings or handle orders. {/*[follow with a screenshot]*/}</li>
          <img src="./meal/img_4.png" style={{maxWidth:"400px"}} alt=""/>
        </ol>
      </div>

      <div className="section">
        <h2>Printer Settings</h2>
        <p>A cashier printer is deployed at the front desk to print cash receipts for customers, and two printers are deployed in the kitchens to print orders for cold and hot dishes respectively. Also, each dish comes with a separate ticket when served.</p>
        {/*[insert screenshots of printer settings and ticket prints]*/}
        <img src="./meal/test5.png"  alt=""/>
      </div>

      <div className="section">
        <h2>Membership Settings</h2>
        <p>In membership settings, set up rules for storing value, which both the front desk and waitstaff can assist customers with.</p>
        {/*[insert screenshot of settings]*/}
        <img src="./meal/img_14.png" alt=""/>
        <img src="./meal/img_15.png" alt=""/>
      </div>

      <div className="section">
        <h2>Tax Settings</h2>
        {/*[insert screenshots of tax settings, checkout page, and receipt images]*/}

      </div>

      <div className="section">
        <h2>Time-Specific Menu</h2>
        <p>Set some dishes to be available only on weekend mornings.</p>
        {/*[insert screenshot of settings]*/}
        <img src="./meal/img_17.png" alt=""/>
      </div>

      <div className="section">
        <h2>Export Orders</h2>
        <p>Allows restaurant partners and managers to conduct in-depth analysis of sales data.</p>
        {/*[insert Excel screenshot]*/}
        <img src="./meal/img_5.png" style={{maxWidth:"400px"}} alt=""/>
      </div>

      <div className="section">
        <h2>Kitchen Display System (KDS)</h2>
        <p>In addition to receiving order information through printed tickets, we also support the use of a Kitchen Display System (KDS) to display orders in the kitchen. Chefs can use a large screen to more clearly understand the order situation. <a href="link_to_kds_details">Click here for more details</a>.</p>
        {/*[insert a schematic photo of the KDS, perhaps using a Western restaurant as an example]*/}
        <img src="./meal/test9.png" alt=""/>
      </div>

      {/*[Additional sections can be added here based on actual content needs]*/}

    </div>
  );
};

export default FineDiningExample;
